import React, { useState } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Autosuggest from 'react-autosuggest';

import apolloClient from '../../services/App/Client';
import { cmsPageRedirect } from '../../views/CMS/utils/routing';
import ReSharperImg from '../ReSharperImg/ReSharperImg';
import SearchBarRequests from './SearchBar.graphql';

// Teach Autosuggest how to calculate suggestions for any given input value.
// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

// Use your imagination to render suggestions.
function renderSuggestion(suggestion) {
  const cover =
    suggestion.covers && suggestion.covers.hits && suggestion.covers.hits[0]
      ? suggestion.covers.hits[0].public_url
      : null;

  return (
    <>
      <ListItem alignItems='flex-start' className={'p-0 m-0'}>
        <ListItemAvatar>
          <div className={'cms-page-card-pages-links-list-item-avatar overflow-hidden'}>
            <ReSharperImg url={cover} w={300} style={{ maxHeight: '50px' }} />
          </div>
        </ListItemAvatar>
        <ListItemText primary={suggestion.name} secondary={suggestion.description} />
      </ListItem>
    </>
  );
}

function renderSectionTitle(section) {
  return <strong>{section.title}</strong>;
}

function getSectionSuggestions(section) {
  return section.items;
}

const SearchBar = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [value, setValue] = useState('');

  const onChange = (event, changedValues) => {
    if (changedValues.method === 'click') {
      cmsPageRedirect({
        pageId: changedValues.newValue.id,
        pageType: changedValues.newValue.type,
      });
      setValue('');
    } else {
      setValue(changedValues.newValue);
    }
  };

  async function getSuggestions(value) {
    if (!value) {
      return [];
    }

    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
      return [];
    }

    const resultBySearchType = [];

    const results = await apolloClient.query({
      query: SearchBarRequests.Query.globalSearch,
      variables: {
        q: escapedValue,
      },
    });

    if (results && results.data && results.data.goGetIt) {
      if (
        results.data.goGetIt.cmsPages &&
        results.data.goGetIt.cmsPages.hits &&
        results.data.goGetIt.cmsPages.hits.length > 0
      ) {
        resultBySearchType.push({
          title: 'Articles',
          items: results.data.goGetIt.cmsPages.hits,
        });
      }
    }

    return resultBySearchType;
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  const onSuggestionsFetchRequested = async ({ value }) => {
    setSuggestions(await getSuggestions(value));
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  // Autosuggest will pass through all these props to the input.
  const inputProps = {
    placeholder: 'Recherche rapide',
    value,
    onChange,
  };

  // Finally, render it!
  return (
    <Autosuggest
      multiSection={true}
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderSectionTitle={renderSectionTitle}
      getSectionSuggestions={getSectionSuggestions}
      inputProps={inputProps}
    />
  );
};

export default SearchBar;
